import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firebase-config';
import { collection, addDoc, getDocs, deleteDoc, doc, query, orderBy } from 'firebase/firestore';
import { Plus, Trash2, CheckCircle, Loader2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import './CategoryManager.css';

// ASSETS IMPORTLARI
import BuyukbasIcon from '../../assets/aaa.svg';
import KucukbasIcon from '../../assets/bbb.svg';
import KanatliIcon from '../../assets/ccc.svg';
import AtIcon from '../../assets/ddd.png'; // Dördüncü ikon için ddd.svg olduğunu varsaydım kanka

const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [newCat, setNewCat] = useState({ 
    title: '', 
    description: '', 
    color: '#1a4731', 
    order: 1, 
    iconType: 'Büyükbaş' 
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');

  // SVG İkon Eşleştirmesi
  const iconOptions = {
    'Büyükbaş': BuyukbasIcon,
    'Küçükbaş': KucukbasIcon,
    'Kanatlı': KanatliIcon,
    'At': AtIcon
  };

  const fetchCategories = async () => {
    const q = query(collection(db, "categories"), orderBy("order", "asc"));
    const querySnapshot = await getDocs(q);
    setCategories(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => { fetchCategories(); }, []);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCat.title || !newCat.description) return;
    setLoading(true);
    try {
      await addDoc(collection(db, "categories"), { ...newCat });
      setNewCat({ title: '', description: '', color: '#1a4731', order: 1, iconType: 'Büyükbaş' });
      setStatus('success');
      fetchCategories();
      setTimeout(() => setStatus(''), 3000);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bu grubu silmek istediğine emin misin?")) {
      await deleteDoc(doc(db, "categories", id));
      fetchCategories();
    }
  };

  return (
    <div className="panel-box">
      <AnimatePresence>
        {status === 'success' && (
          <motion.div initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 50 }} className="status-toast">
            <CheckCircle size={22} /> <span>Bigma Grup Eklendi!</span>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="admin-header-flex">
        <h3>Ürün Grupları Yönetimi</h3>
      </div>

      <form className="category-add-form" onSubmit={handleAddCategory}>
        <div className="form-row-modern">
          <div className="form-group">
            <label>Grup Adı</label>
            <input type="text" value={newCat.title} onChange={(e) => setNewCat({...newCat, title: e.target.value})} placeholder="Örn: Süt Yemleri" required />
          </div>
          <div className="form-group">
            <label>Hayvan Türü (İkon Seçimi)</label>
            <select value={newCat.iconType} onChange={(e) => setNewCat({...newCat, iconType: e.target.value})} className="icon-select">
              {Object.keys(iconOptions).map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Kurumsal Renk</label>
            <div className="color-input-wrapper">
              <input type="color" value={newCat.color} onChange={(e) => setNewCat({...newCat, color: e.target.value})} />
              <span>{newCat.color}</span>
            </div>
          </div>
          <div className="form-group">
            <label>Sıralama</label>
            <input type="number" value={newCat.order} onChange={(e) => setNewCat({...newCat, order: parseInt(e.target.value)})} />
          </div>
        </div>

        <div className="form-group full-width">
          <label>Kısa Tanıtım Metni</label>
          <textarea rows="2" value={newCat.description} onChange={(e) => setNewCat({...newCat, description: e.target.value})} placeholder="Yem grubunun özelliklerini kısaca yaz kanka..." required />
        </div>

        <button type="submit" className="save-btn add-cat-btn" disabled={loading}>
          {loading ? <Loader2 className="animate-spin" /> : <><Plus size={18} /> Yeni Grup Oluştur</>}
        </button>
      </form>

      <div className="category-list-grid">
        {categories.map((cat) => (
          <div key={cat.id} className="category-manage-card">
            <div className="cat-icon-container" style={{ backgroundColor: cat.color + '15' }}>
               {/* SVG İKONU BURADA GÖSTERİYORUZ */}
              <img 
                src={iconOptions[cat.iconType]} 
                alt={cat.iconType} 
                className="cat-custom-svg" 
                style={{ filter: `drop-shadow(0 0 5px ${cat.color})` }}
              />
            </div>
            <div className="cat-info">
              <h4>{cat.title}</h4>
              <p style={{ color: cat.color }}>{cat.iconType} Kategorisi</p>
            </div>
            <button className="delete-cat-btn" onClick={() => handleDelete(cat.id)}><Trash2 size={18} /></button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryManager;